import React, { useState } from 'react';

export default function AvailableServices({ element, translations, showServiceInfo, setShowServiceInfo}) {

    const handleShowServiceInfo = (elementId, e, obj) => {
        e.preventDefault();
        e.stopPropagation();
        let elem = document.querySelector('#' + elementId);
        let rect = elem.getBoundingClientRect();

        const serviceInfo = {
            ...obj,
            rect: rect
        }

        setShowServiceInfo(serviceInfo);
    }
    
    return (element && element.services && translations &&
        <div className="subsidiary-services-wrapper | light-neutral-10">
            <h2 className="service-title | font-heading-s font-heading-desktop-m fw-400">{translations.services}</h2>
            <ul className="services">
                {
                    element.services.map((service, i) => (
                        <li key={'service_' + service.serviceId}
                            id={"service_" + element.subsidiaryId + "_" + service.serviceId}>
                                    <span
                                        style={{cursor: "pointer"}}
                                        className="icon"
                                        onClick={(e) => handleShowServiceInfo("service_" + element.subsidiaryId + "_" + service.serviceId, e, { serviceId: service.serviceId, itemId: element.subsidiaryId, abstract: service.popup })}
                                    >
                                    <img className="service-img"
                                         src={"/documents/" + JSON.parse(service.icon).groupId + "/" + JSON.parse(service.icon).uuid}/>
                                    </span>
                            <span style={{display: "flex", flexDirection: "column", cursor: "pointer"}}>
                                        <a
                                            className="text link-cta link-cta-icon green-dark"
                                            onClick={(e) => handleShowServiceInfo("service_" + element.subsidiaryId + "_" + service.serviceId, e, { serviceId: service.serviceId, itemId: element.subsidiaryId, abstract: service.popup })}
                                        >
                                            <span className="title">{service.title}</span>
                                        </a>
                                        <a
                                            className="text link-cta green-dark"
                                            onClick={(e) => handleShowServiceInfo("service_" + element.subsidiaryId + "_" + service.serviceId, e, { serviceId: service.serviceId, itemId: element.subsidiaryId, abstract: service.popup })}
                                        >
                                            <span className="subtitle">{service.subTitle}</span>
                                        </a>
                                    </span>
                        </li>
                    ))
                }
            </ul>
        </div>
    );
}